export const RoleList = {
  AUTHORITY_USER_IS_CUSTOMER: "AUTHORITY_USER_IS_CUSTOMER",
  AUTHORITY_SYSTEM: "AUTHORITY_SYSTEM",
  AUTHORITY_ADMIN: "AUTHORITY_ADMIN",
  AUTHORITY_USER_IS_NOT_CUSTOMER: "AUTHORITY_USER_IS_NOT_CUSTOMER",
};
